import { useTranslation } from "react-i18next";
import { Navigation } from "../../components";
import { Box, Typography } from "../../shared/ui";
import css from "./GameRules.module.scss";

export const GameRules = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Navigation title={t("game_rules.title")} />
      <Box className={css.container}>
        <Typography className={css.title} color="header-small">
          {t("game_rules.overview")}
        </Typography>
        <Typography className={css.descr} color="light-grey">
          {t("game_rules.overview_text")}
        </Typography>
        <Typography className={css.title} color="header-small">
          {t("game_rules.rtp")}
        </Typography>
        <Typography className={css.descr} color="light-grey">
          {t("game_rules.rtp_text")}
        </Typography>
        <Typography className={css.title} color="header-small">
          {t("game_rules.game_flow")}
        </Typography>
        <Typography className={css.descr} color="light-grey">
          {t("game_rules.game_flow_text")}
        </Typography>
        <ol className={`${css.list} ${css.orderedList}`}>
          <li className={css.listItem}>{t("game_rules.betting_phase")}</li>
          <li className={css.listItem}>{t("game_rules.active_round")}</li>
          <li className={css.listItem}>{t("game_rules.cash_out_option")}</li>
          <li className={css.listItem}>{t("game_rules.crash_event")}</li>
        </ol>
        <Typography className={css.descr} color="light-grey">
          {t("game_rules.after_crash")}
        </Typography>
        <Typography className={css.title} color="header-small">
          {t("game_rules.how_wins_are_calculated")}
        </Typography>
        <Typography className={css.descr} color="light-grey">
          {t("game_rules.how_wins_are_calculated_text")}
        </Typography>
        <Typography className={css.title} color="header-small">
          {t("game_rules.multiple_bets.title")}
        </Typography>
        <Typography className={css.descr} color="light-grey">
          {t("game_rules.multiple_bets")}
        </Typography>
        <Typography className={css.title} color="header-small">
          {t("game_rules.auto_play_and_auto_cashout")}
        </Typography>
        <Typography className={css.descr} color="light-grey">
          {t("game_rules.auto_play")}
        </Typography>
        <ul className={`${css.list} ${css.unorderedList}`}>
          <li className={css.listItem}>{t("game_rules.stop_on_profit")}</li>{" "}
          <li className={css.listItem}>{t("game_rules.stop_on_loss")}</li>{" "}
          <li className={css.listItem}>{t("game_rules.stop_on_single_win")}</li>
        </ul>
        <Typography className={css.descr} color="light-grey">
          {t("game_rules.auto_cashout")}
        </Typography>
        <Typography className={css.title} color="header-small">
          {t("game_rules.maximum_win.title")}
        </Typography>
        <Typography className={css.descr} color="light-grey">
          {t("game_rules.maximum_win")}
        </Typography>
        <Typography className={css.title} color="header-small">
          {t("game_rules.disconnection_policy")}
        </Typography>
        <ul className={`${css.list} ${css.unorderedList}`}>
          <li className={css.listItem}>
            {t("game_rules.disconnection_policy_text_1")}
          </li>

          <li className={css.listItem}>
            {t("game_rules.disconnection_policy_text_2")}
          </li>
          <li className={css.listItem}>
            {t("game_rules.disconnection_policy_text_3")}
          </li>
        </ul>
        <Typography className={css.title} color="header-small">
          {t("game_rules.randomness_and_fairness.title")}
        </Typography>
        <Typography className={css.descr} color="light-grey">
          {t("game_rules.randomness_and_fairness")}
        </Typography>
        <Typography className={css.title} color="header-small">
          {t("game_rules.responsible_gaming_notice.title")}
        </Typography>
        <Typography className={css.descr} color="light-grey">
          {t("game_rules.responsible_gaming_notice")}
        </Typography>
      </Box>
    </Box>
  );
};
